export * from './triage-scale-setup.service';